import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges, model, OnInit } from '@angular/core';
import { ActivityService } from 'src/app/core/services/activity.service';
import {
  ProcessTypeListBodyObj,
  isApplicantsActivityAvailable,
  CheckSuitabilityDataObj,
  DataIds,
  CheckInterviewSchDataObj,
  CheckstatusChangeObj,
  CorrespondenceDataObj,
  HrPanelInterviewObj,
} from '../../../shared/models/activity-dashboard-model';
import { Iactivity, IroleProcessActivity } from 'src/app/shared/models/activity';

import { SchedulerCandidate } from '../../../shared/models/schedulerAssociate';

import { Router } from '@angular/router';
import { SearchCandidateService } from '../../../core/services/searchCandService-service';
@Component({
  selector: 'app-activity-footer',
  templateUrl: './activity-footer.component.html',
  styleUrls: ['./activity-footer.component.scss'],
  standalone: false,
})
export class ActivityFooterComponent implements OnChanges, OnInit {
  onCorrespondence: boolean = false;
  onSuitability: boolean = false;

  onPreScreen: boolean = false;
  onScreen: boolean = false;
  onInterview: boolean = false;
  @Input() processStage;
  @Output()
  refreshcandidate: EventEmitter<any> = new EventEmitter();
  companyHiringType = localStorage.getItem('fresherCompHiringTypeId');

  //@Input() applicationId;
  @Input() application;
  @Input() selectedCandidate: SchedulerCandidate[];
  @Input() processTypeList;
  autoTriggerActivity = model();
  candidateApplicationIds: number[] = [];
  @Output() suitabiltyCheckEvent: EventEmitter<CheckSuitabilityDataObj> = new EventEmitter<CheckSuitabilityDataObj>();
  roleProcessActivityList: IroleProcessActivity[] = [];
  suitabilityEvent(obj: CheckSuitabilityDataObj) {
    //this.onSuitability = show;
    console.log('inside suitability event');
    this.suitabiltyCheckEvent.emit(obj);
  }
  @Output() coupledSuitabiltyCheckEvent: EventEmitter<CheckSuitabilityDataObj> =
    new EventEmitter<CheckSuitabilityDataObj>();
  coupledsuitabilityEvent(obj: CheckSuitabilityDataObj) {
    //this.onSuitability = show;
    console.log('inside suitability event');
    this.coupledSuitabiltyCheckEvent.emit(obj);
  }
  @Output() coupled2SuitabiltyCheckEvent: EventEmitter<CheckSuitabilityDataObj> =
    new EventEmitter<CheckSuitabilityDataObj>();
  coupled2suitabilityEvent(obj: CheckSuitabilityDataObj) {
    //this.onSuitability = show;
    console.log('inside suitability event');
    this.coupled2SuitabiltyCheckEvent.emit(obj);
  }

  @Output() interviewCheckEvent: EventEmitter<CheckInterviewSchDataObj> = new EventEmitter<CheckInterviewSchDataObj>();
  interviewScheEvent(obj: CheckInterviewSchDataObj) {
    console.log(obj);
    console.log('insircorresponadence event');

    this.interviewCheckEvent.emit(obj);
    // this.correspondenceEvent(false);
  }

  @Output() coupledInterviewCheckEvent: EventEmitter<CheckInterviewSchDataObj> =
    new EventEmitter<CheckInterviewSchDataObj>();
  coupledinterviewScheEvent(obj: CheckInterviewSchDataObj) {
    console.log(obj);

    this.coupledInterviewCheckEvent.emit(obj);
    // this.correspondenceEvent(false);
  }

  @Output() coupled2InterviewCheckEvent: EventEmitter<CheckInterviewSchDataObj> =
    new EventEmitter<CheckInterviewSchDataObj>();
  coupled2interviewScheEvent(obj: CheckInterviewSchDataObj) {
    console.log(obj);

    this.coupled2InterviewCheckEvent.emit(obj);
    // this.correspondenceEvent(false);
  }

  @Output() statusEvent: EventEmitter<CheckstatusChangeObj> = new EventEmitter<CheckstatusChangeObj>();
  statusChangeEvent(obj: CheckstatusChangeObj) {
    console.log(obj);
    console.log('inside stauts event');
    this.statusEvent.emit(obj);
    // this.correspondenceEvent(false);
  }

  @Output() coupledStatusEvent: EventEmitter<CheckstatusChangeObj> = new EventEmitter<CheckstatusChangeObj>();
  coupledstatusChangeEvent(obj: CheckstatusChangeObj) {
    console.log(obj);

    this.coupledStatusEvent.emit(obj);
    // this.correspondenceEvent(false);
  }
  @Output() coupled2StatusEvent: EventEmitter<CheckstatusChangeObj> = new EventEmitter<CheckstatusChangeObj>();
  coupled2statusChangeEvent(obj: CheckstatusChangeObj) {
    console.log(obj);

    this.coupled2StatusEvent.emit(obj);
    // this.correspondenceEvent(false);
  }

  @Output() correspondenceCheckEvent: EventEmitter<CorrespondenceDataObj> = new EventEmitter<CorrespondenceDataObj>();
  correspondenceEvent(correspondenceDataObj: CorrespondenceDataObj) {
    this.onCorrespondence = true;
    this.correspondenceCheckEvent.emit(correspondenceDataObj);
  }

  @Output() coupledCorrespondenceCheckEvent: EventEmitter<CorrespondenceDataObj> =
    new EventEmitter<CorrespondenceDataObj>();
  coupledcorrespondenceEvent(correspondenceDataObj: CorrespondenceDataObj) {
    console.log('inside correespondence event');
    this.onCorrespondence = true;
    this.coupledCorrespondenceCheckEvent.emit(correspondenceDataObj);
    console.log('event emitted to candidatedetails');
  }
  @Output() coupled2CorrespondenceCheckEvent: EventEmitter<CorrespondenceDataObj> =
    new EventEmitter<CorrespondenceDataObj>();
  coupled2correspondenceEvent(correspondenceDataObj: CorrespondenceDataObj) {
    console.log('inside correespondence event');
    this.onCorrespondence = true;
    this.coupled2CorrespondenceCheckEvent.emit(correspondenceDataObj);
    console.log('event emitted to candidatedetails');
  }

  @Output() ROAEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  ROA(show) {
    this.onSuitability = show;
    this.ROAEvent.emit(this.onSuitability);
    // this.correspondenceEvent(true);
  }

  @Output() updateifcoupled: EventEmitter<boolean> = new EventEmitter<boolean>();
  updateIfCoupled(flag) {
    const updateifcoupled = flag;
    this.updateifcoupled.emit(updateifcoupled);
  }

  @Output() updateactivityselected: EventEmitter<boolean> = new EventEmitter<boolean>();
  updateselectedactivity() {
    // let updateifcoupled = flag;
    this.updateactivityselected.emit(true);
  }

  @Output() hrPanelUpdateEvent: EventEmitter<HrPanelInterviewObj> = new EventEmitter<HrPanelInterviewObj>();
  updateHRPanel(HrPanelInterviewObj: HrPanelInterviewObj) {
    this.hrPanelUpdateEvent.emit(HrPanelInterviewObj);
  }
  @Output() coupledhrPanelUpdateEvent: EventEmitter<HrPanelInterviewObj> = new EventEmitter<HrPanelInterviewObj>();
  updatecoupledHRPanel(HrPanelInterviewObj: HrPanelInterviewObj) {
    this.coupledhrPanelUpdateEvent.emit(HrPanelInterviewObj);
  }
  @Output() coupled2hrPanelUpdateEvent: EventEmitter<HrPanelInterviewObj> = new EventEmitter<HrPanelInterviewObj>();
  updatecoupled2HRPanel(HrPanelInterviewObj: HrPanelInterviewObj) {
    this.coupled2hrPanelUpdateEvent.emit(HrPanelInterviewObj);
  }
  // @Output() questionnairesCreateEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  // QuestionnairesEvent(){
  //   this.onCorrespondance = false;
  //   this.onSchedule = false;
  //   this.onSuitability = false;

  //   this.onQuestionnaires = true;

  //   this.questionnairesCreateEvent.emit(this.onQuestionnaires);

  // }

  // @Output() statusEvent:EventEmitter<boolean> = new EventEmitter<boolean>();
  // statusChangeEvent(){
  //   this.onCorrespondance = false;
  //   this.onSchedule = false;
  //   this.onSuitability = false;
  //   this.onQuestionnaires = false;

  //   this.onStatusChange = true;

  //   this.statusEvent.emit(this.onStatusChange);

  // }

  //  @@@@ parked as of now @@@@
  @Output() customPreScreeningEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  preScreeningEvent() {
    console.log('hi');

    this.onPreScreen = true;
    this.customPreScreeningEvent.emit(this.onPreScreen);
  }

  @Output() customScreeningEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  screeningEvent() {
    this.onScreen = true;
    this.customScreeningEvent.emit(this.onScreen);
  }

  @Output() customInterviewEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  interviewEvent() {
    this.onInterview = true;
    this.customInterviewEvent.emit(this.onInterview);
  }

  getProcessTypes() {
    console.log('inside get process');
    const body: ProcessTypeListBodyObj = { applicationId: this.application };
    this.processTypeList = this.activityService.getProcessType(body);
    console.log(this.processTypeList);
    console.log(this.application.applicationId);
  }

  subActivity(processId: number, activity: Iactivity) {
    this.activityService.setAct(activity.activityId);
    if (activity.activityId == 600101 && this.companyHiringType == '2') {
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];
      this.activityService
        .getSFO(this.selectedCandidate[0].candidateId, this.companyHiringType, this.selectedCandidate[0].applicationId)
        .subscribe((sfodata) => {
          if (sfodata != 'Success') {
            activity.write = false;
            const data = {
              msg: sfodata,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
            return;
          } else {
            activity.write = true;
            this.router.navigate(['/offermicro/fresher']);
          }
        });
      return;
    }
    if ((activity.activityId == 600101 || activity.activityId == 600102) && this.companyHiringType == '4') {
      // propose offer for bpm online
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];

      this.activityService
        .getSFO(this.selectedCandidate[0].candidateId, this.companyHiringType, this.selectedCandidate[0].applicationId)
        .subscribe((sfodata) => {
          if (sfodata != 'Success') {
            activity.write = false;
            const data = {
              msg: sfodata,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
            return;
          } else {
            activity.write = true;
            this.router.navigate(['/offermicro/bpmOnlineOffer']);
          }
        });
      return;
    }
    if ((activity.activityId == 600101 || activity.activityId == 600102) && this.companyHiringType == '1') {
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];
      localStorage.setItem('latScr', 'true');
      this.router.navigate(['/offermicro/lateraloffer']);
      return;
    }
    if (activity.activityId == 600101 && this.companyHiringType == '6') {
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];
      localStorage.setItem('latScr', 'true');
      this.router.navigate(['/offermicro/chinaOffer']);
      return;
    }
    // if (activity.activityId == 600102  && this.companyHiringType == '1') {
    //   window['activityItem'] = activity;
    //   window['selectedCandidate'] = this.selectedCandidate[0];
    //   this.router.navigate(['/offermicro/lateraloffer']);
    //   return;
    // }

    if (activity.activityId == 600102 && this.companyHiringType == '4') {
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];
      this.activityService
        .getSFO(this.selectedCandidate[0].candidateId, this.companyHiringType, this.selectedCandidate[0].applicationId)
        .subscribe((sfodata) => {
          if (sfodata != 'Success') {
            activity.write = false;
            const data = {
              msg: sfodata,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
            return;
          } else {
            activity.write = true;
            this.router.navigate(['/offermicro/bpmOnlineOffer']);
          }
        });
      return;
    }
    if (activity.activityId == 600102 && this.companyHiringType == '2') {
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];
      this.activityService
        .getSFO(this.selectedCandidate[0].candidateId, this.companyHiringType, this.selectedCandidate[0].applicationId)
        .subscribe((sfodata) => {
          if (sfodata != 'Success') {
            activity.write = false;
            const data = {
              msg: sfodata,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
            return;
          } else {
            activity.write = true;
            this.router.navigate(['/offermicro/bpmoffer/bpmofflineoffer']);
          }
        });
      return;
    }

    if (activity.activityId == 600103 && this.companyHiringType == '9') {
      const lastActivityId = this.activityService.lastActivityPerformed?.activityid;
      const allowedPreActivities = [600103, 600303, 600304];

      if (!allowedPreActivities.includes(lastActivityId)) {
        activity.write = false;
        const data = {
          msg: 'To perform update offer details, pre-activity should be offer released, offer accepted or update offer details',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data, 'danger-snack');
        return;
      }
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];
      const history = this.activityService.allActivityPerformed || [];
      const hadOffline = history.some((a) => a.activityid === 600102);
      const hadOnline = history.some((a) => a.activityid === 600101);
      if (!hadOffline && hadOnline) {
        activity.write = true;
        this.router.navigate(['/offermicro/bpmOnlineOffer/manilaOnlineOffer'], { state: { source: 'updateOffer' } });
        return;
      } else if (hadOffline) {
        activity.write = true;
      }
    }
    if ((activity.activityId == 600101 || activity.activityId == 600102) && this.companyHiringType == '9') {
      window['activityItem'] = activity;
      window['selectedCandidate'] = this.selectedCandidate[0];
      this.activityService
        .getSFO(this.selectedCandidate[0].candidateId, this.companyHiringType, this.selectedCandidate[0].applicationId)
        .subscribe((sfodata) => {
          if (sfodata != 'Success') {
            activity.write = false;
            const data = {
              msg: sfodata,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
            return;
          } else {
            activity.write = true;
            if (activity.activityId == 600101) {
              this.router.navigate(['/offermicro/bpmOnlineOffer/manilaOnlineOffer'], {
                state: { source: 'proposeOffer' },
              });
              return;
            } else if (activity.activityId == 600102) {
              if (
                this.companyHiringType == '9' &&
                this.activityService.lastActivityPerformed.activityid == 600101 &&
                this.searchcan.getSubstatus() == 'Rejected by CnB'
              ) {
                this.router.navigate(['/offermicro/bpmoffer/bpmofflineoffer'], { queryParams: { formEnable: true } });
                return;
              } else {
                this.router.navigate(['/offermicro/bpmoffer/bpmofflineoffer']);
                return;
              }
            }
          }
        });
      return;
    }

    this.updateselectedactivity();
    const tempIdObj: DataIds = {
      applicationId: Number(this.selectedCandidate[0].applicationId),
      processID: processId,
      activityID: activity.activityId,
    };
    this.activityService.setDataIds(tempIdObj);

    console.log('inside sub activity');
    this.activityService.isApplicantsActivityAvailable().subscribe((response: isApplicantsActivityAvailable) => {
      console.log(response.singleActivityTypeIsExists, response.singleActivityType, activity.activityDescription);
      // couple activity
      // if (true)
      if (response.coupledctivityTypeIsExists) {
        this.updateIfCoupled(true);
        console.log('inside if of coupled in activity footer');

        this.callActivityFunction2(
          response.singleActivityTypeIsExists,
          response.singleActivityType.toLowerCase(),
          activity.activityDescription,
          tempIdObj.applicationId,
          tempIdObj.processID,
          tempIdObj.activityID,
          activity.statusId,
          false,
        );
        if (response.coupledctivityType.toLowerCase() == 'simple correspondence') {
          this.callActivityFunction2(
            response.coupledctivityTypeIsExists,
            response.coupledctivityType.toLowerCase(),
            response.coupleActivityDescription,
            tempIdObj.applicationId,
            tempIdObj.processID,
            response.coupledActivityId,
            activity.statusId,
            true,
            true,
          );
        } else {
          this.callActivityFunction2(
            response.coupledctivityTypeIsExists,
            response.coupledctivityType.toLowerCase(),
            response.coupleActivityDescription,
            tempIdObj.applicationId,
            tempIdObj.processID,
            response.coupledActivityId,
            activity.statusId,
            true,
          );
        }

        //  this.callActivityFunction2(false,'simple activity',activity.activityDescription,tempIdObj.applicationId,tempIdObj.processID,tempIdObj.activityID,activity.statusId,false);
        //  this.callActivityFunction2(true,'simple activity',activity.activityDescription,tempIdObj.applicationId,tempIdObj.processID,tempIdObj.activityID,activity.statusId,true);

        console.log('back to subactivity');
      } else {
        console.log('back to subactivity' + response.coupledctivityTypeIsExists);
        this.callActivityFunction(
          response.singleActivityTypeIsExists,
          response.singleActivityType.toLowerCase(),
          activity.activityDescription,
          tempIdObj.applicationId,
          tempIdObj.processID,
          tempIdObj.activityID,
          activity.statusId,
        );
        // this.callActivityFunction(response.singleActivityTypeIsExists, 'simple correspondence', activity.activityDescription, tempIdObj.applicationId, tempIdObj.processID, tempIdObj.activityID, activity.statusId);
      }
    });
    console.log('activity selected', activity);
  }

  callActivityFunction(
    isActivityAvailable: boolean,
    activityType: string,
    activityName: string,
    applicationId: number,
    processID: number,
    activityId: number,
    statusId: number,
  ) {
    console.log('inside callactivity');
    switch (activityType) {
      case 'simple activity': {
        console.log(isActivityAvailable);

        const obj: CheckSuitabilityDataObj = {
          isVisible: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processID,
          activityId: activityId,
          statusId: statusId,
        };
        console.log('elseeee!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!' + obj);
        this.suitabilityEvent(obj);
        // }
        break;
      }
      case 'simple correspondence': {
        console.log('inside correespondance');

        const obj: CorrespondenceDataObj = {
          isVisible: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processID,
          activityId: activityId,
          statusId: statusId,
        };
        this.correspondenceEvent(obj);
        //}
        break;
      }

      case 'interview': {
        const obj: CheckInterviewSchDataObj = {
          isVisisble: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processID,
          activityId: activityId,
          statusId: statusId,
        };
        this.interviewScheEvent(obj);
        // }
        break;
      }
      case 'confirmation': {
        let isHrActivity = true;
        if (activityName.toLowerCase().includes('panel') || activityName.toLowerCase().includes('ai bot')) {
          isHrActivity = false;
          console.log('isHrActivity', isHrActivity);
        }
        console.log('ishractivity outside loop', isHrActivity);

        console.log('inside HR pabel obj');
        const obj: HrPanelInterviewObj = {
          isVisible: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processID,
          activityId: activityId,
          statusId: statusId,
          isHrActivity: isHrActivity,
        };
        this.updateHRPanel(obj);
        // }
        break;
      }

      case 'status change': {
        const obj: CheckstatusChangeObj = {
          isVisisble: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processID,
          activityId: activityId,
          statusId: statusId,
        };
        this.statusChangeEvent(obj);
        // }
        break;
      }
      default: {
      }
    }
  }

  // couple activity

  callActivityFunction2(
    isActivityAvailable: boolean,
    activityType: string,
    activityName: string,
    applicationId: number,
    processId: number,
    activityId: number,
    statusId: number,
    isCoupledCall: boolean,
    rejection?: boolean,
  ) {
    console.log('inside callactivity 2');
    switch (activityType) {
      case 'simple activity': {
        console.log(isActivityAvailable);

        const obj: CheckSuitabilityDataObj = {
          isVisible: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processId,
          activityId: activityId,
          statusId: statusId,
        };
        if (isCoupledCall) {
          this.coupled2suitabilityEvent(obj);
        } else {
          this.coupledsuitabilityEvent(obj);
        }

        break;
      }
      case 'simple correspondence': {
        console.log('inside correespondance');

        const obj: CorrespondenceDataObj = {
          isVisible: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processId,
          activityId: activityId,
          statusId: statusId,
          rejection: rejection,
        };
        if (isCoupledCall) {
          this.coupled2correspondenceEvent(obj);
        } else {
          this.coupledcorrespondenceEvent(obj);
        }

        //}
        break;
      }

      case 'interview': {
        const obj: CheckInterviewSchDataObj = {
          isVisisble: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,

          applicationId: applicationId,
          processId: processId,
          activityId: activityId,
          statusId: statusId,
        };
        if (isCoupledCall) {
          this.coupled2interviewScheEvent(obj);
        } else {
          this.coupledinterviewScheEvent(obj);
        }

        // }
        break;
      }

      case 'status change': {
        const obj: CheckstatusChangeObj = {
          isVisisble: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,

          processId: processId,
          applicationId: applicationId,
          activityId: activityId,
          statusId: statusId,
        };
        if (isCoupledCall) {
          this.coupled2statusChangeEvent(obj);
        } else {
          this.coupledstatusChangeEvent(obj);
        }

        // }
        break;
      }
      case 'confirmation': {
        let isHrActivity = true;
        if (activityName.toLowerCase().includes('panel')) {
          isHrActivity = false;
          console.log('isHrActivity', isHrActivity);
        }
        console.log('ishractivity outside loop', isHrActivity);

        console.log('inside HR pabel obj');
        const obj: HrPanelInterviewObj = {
          isVisible: true,
          candidateName: this.selectedCandidate[0].name,
          activityName: activityName,
          applicationId: applicationId,
          processId: processId,
          activityId: activityId,
          statusId: statusId,
          isHrActivity: isHrActivity,
        };
        if (isCoupledCall) {
          this.updatecoupled2HRPanel(obj);
        } else {
          this.updatecoupledHRPanel(obj);
        }
        this.updateHRPanel(obj);
        // }
        break;
      }
      default: {
      }
    }
  }

  constructor(
    private activityService: ActivityService,
    public router: Router,
    private searchcan: SearchCandidateService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    // When processTypeList arrives AND autoTriggerActivity is set, auto-fire the matching activity
    if (changes['processTypeList']?.currentValue && this.autoTriggerActivity()) {
      setTimeout(() => this.triggerAutoActivity(), 0);
    }
  }

  private triggerAutoActivity(): void {
    if (!this.autoTriggerActivity() || !this.processTypeList?.length) {
      return;
    }
    for (const process of this.processTypeList) {
      const match = process.activityprocess?.find((a: any) => a.activityDescription === this.autoTriggerActivity());
      if (match) {
        this.subActivity(process.processId, match);
        break;
      }
    }
  }

  //   console.log('inside footer')
  //   let roleProcessList:any;
  //   this.processTypeList.array.forEach(element => {console.log('element',element);

  //   });
  //   this.selectedCandidate.forEach(value => {
  //     this.candidateApplicationIds.push(Number(value.applicationId));
  //   });

  //   console.log('candidateapplication id', this.candidateApplicationIds);

  // }
  ngOnInit() {
    console.log('inside footer');
    this.selectedCandidate.forEach((value) => {
      this.candidateApplicationIds.push(Number(value.applicationId));
    });

    console.log('candidateapplication id', this.candidateApplicationIds);
    console.log('proceesslist-->', this.processTypeList);

    this.processTypeList.forEach((element) => {
      console.log('element', element);
      // let obj:any={
      // processId:element.processId,
      // processName:element.processName,
      // }
      const obj: Iactivity[] = [];
      // obj.processId=element.processId;
      // obj.processName=element.processName;
      element.activityprocess.forEach((activity) => {
        if (activity.read) {
          obj.push(activity);
        }
      });
      const obj1: any = {
        processId: element.processId,
        processName: element.processName,
        activityprocess: obj,
      };
      this.roleProcessActivityList.push(obj1);
    });
    console.log('roleprocess---->', this.roleProcessActivityList);
  }
}
